<template>
  <div>
    <div class="pushtop" />
    <div
      v-if="visitorInfo.isLoggedIn"
      class="container"
    >
      <div
        v-show="messageCard"
        v-if="petAd && petAd.createdBy !== visitorInfo.id"
        class="message-card"
      >
        <div class="message-card-content">
          <div class="message-card-header">
            <h4>Send a message to the seller</h4>
            <button
              class="btn btn-close position-absolute top-0 end-0"
              aria-label="Close"
              @click="MessageCardToggle"
            >
              <i class="lnr lnr-cross" />
            </button>
          </div>
          <div class="message-card-body">
            <form>
              <div class="form-group">
                <label for="message">Message</label>
                <textarea
                  id="message"
                  v-model="messageText"
                  class="form-control"
                  rows="5"
                  placeholder="Type your message here..."
                  :disabled="isPending"
                />
              </div>
              <div>
                <p>Ad ID: {{ petAd.id }}</p>
                <p>Seller ID: {{ petAd.createdBy }}</p>
                <p>Visitor ID: {{ visitorInfo.id }}</p>
                <p>Owner email: {{ petAd.owner }}</p>
                <p>Owner name: {{ petAd.ownerName }}</p>
                <p>Owner photo: {{ petAd.ownerPhotoURL }}</p>
              </div>
              <div
                v-if="sendError"
                class="alert alert-danger"
              >
                {{ sendError }}
              </div>
              <button
                type="button"
                class="btn btn-primary"
                :disabled="isPending || !messageText.trim()"
                @click="handleSendMessage"
              >
                {{ isPending ? 'Sending...' : 'Send' }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <section class="product_description_area">
      <div class="feature_product_area latest_product_area petlisting">
        <div class="main_box ilan-sag">
          <div class="container">
            <div
              class="row text-center"
              style="margin: 0 auto; font-size: 12px; width: 100%; justify-content: flex-start; padding-top: 15px; padding-bottom: 15px;"
            >
              <div class="banner_content">
                <div class="page_link breadc">
                  <a
                    href="javascript:void(0)"
                    @click="$router.push('/')"
                  >Home </a>
                  <a href="" />
                  <a
                    href="javascript:void(0)"
                    @click="$router.go(-1)"
                  >Go Back</a>
                </div>
              </div>
              <div class="float-right" />
            </div>
            <div
              v-if="loading"
              class="loading"
            >
              <LoadingSpinner />
              <p>Loading...</p>
            </div>
            <div
              v-if="error"
              class="error"
            >
              {{ error }}
            </div>
            <div
              v-if="petAd"
              class="row s_product_inner"
            >
              <div
                id="image__box"
                class="col-lg-6 image__box"
              >
                <div class="mb-2">
                  <h4>
                    <router-link :to="`/pets?category=${petAd.category}`">
                      <button
                        class="btn btn-primary"
                        type="button"
                      >
                        {{ petAd.category }}
                      </button>
                    </router-link>
                    /
                    {{ petAd.subCategory }}
                  </h4>
                </div>

                <!-- Ana Carousel -->
                <Carousel
                  v-if="allImages && allImages.length"
                  id="gallery"
                  ref="carousel"
                  v-bind="galleryConfig"
                  v-model="currentSlide"
                >
                  <Slide
                    v-for="(image, index) in allImages"
                    :key="image"
                  >
                    <img
                      :src="image"
                      alt="Gallery Image"
                      class="gallery-image"
                      @click="showImg(index)"
                    >
                  </Slide>
                </Carousel>

                <vue-easy-lightbox
                  :visible="visible"
                  :imgs="allImages"
                  :index="imageIndex"
                  @hide="handleHide"
                />

                <!-- Küçük Resimler Carousel -->
                <Carousel
                  v-if="allImages.length"
                  id="thumbnails"
                  v-bind="thumbnailsConfig"
                  v-model="currentSlide"
                >
                  <Slide
                    v-for="image in allImages"
                    :key="image"
                  >
                    <template #default="{ currentIndex, isActive }">
                      <div
                        :class="['thumbnail', { 'is-active': isActive }]"
                        @click="slideTo(currentIndex)"
                      >
                        <img
                          :src="image"
                          alt="Thumbnail Image"
                          class="thumbnail-image"
                        >
                      </div>
                    </template>
                  </Slide>
                  <template #addons>
                    <Navigation />
                  </template>
                </Carousel>
              </div>

              <div class="col-lg-5">
                <div class="s_product_text">
                  <h2>{{ petAd.title }}</h2>

                  <h1>£{{ petAd.price }}</h1>
                  <ul class="list">
                    <li>
                      <a class="active"><span>Ad Number</span> 101598</a>
                    </li>
                    <li>
                      <a class="active"><span>Seller</span> {{ petAd.ownerName }}</a>
                    </li>
                    <li>
                      <a class="active"><span>Category</span> {{ petAd.category }} / {{ petAd.subCategory }}</a>
                    </li>
                    <li>
                      <a class="active"><span>Added </span> {{ formattedCreatedAt }}</a>
                    </li>
                    <li>
                      <a class="active"><span>seller id</span> {{ petAd.createdBy }} </a>
                    </li>
                    <li>
                      <a class="active"><span>visitor id</span> {{ visitorInfo.id }} </a>
                    </li>
                  </ul>
                  <div class="card_area">
                    <a
                      class="icon_btn"
                      href="javascript:void(0);"
                      data-bs-toggle="tooltip"
                      data-bs-title="Like It"
                    >
                      <i class="icon-hearts" />
                    </a>
                    <div
                      v-show="petAd.createdBy !== visitorInfo.id"
                      class="btn-group"
                      role="group"
                    >
                      <button
                        type="button"
                        class="grid-icon2 dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Contact
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <button
                            type="button"
                            class="dropdown-item"
                            @click="MessageCardToggle"
                          >
                            Message
                          </button>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >Call</a>
                        </li>
                      </ul>
                    </div>
                    <a
                      v-show="petAd.createdBy !== visitorInfo.id"
                      class="icon_btn"
                      style="margin-left: 10px"
                      href="javascript:void(0);"
                    >
                      <i class="icon-alarm-ringing" />
                    </a>
                  </div>
                  <ul class="list">
                    <li>
                      <span> <i
                        class="icon-file-preview"
                        style="font-size: 20px"
                      /></span> : {{ petAd.viewed || 0 }}
                      Viewed
                    </li>
                    <li>
                      <span> <i
                        class="lnr lnr lnr-heart"
                        style="font-size: 20px"
                      /></span> : 0
                      Liked
                    </li>
                  </ul>
                </div>
                <div id="listingdetailstab">
                  <ul class="nav nav-tabs">
                    <li class="nav-item">
                      <div
                        class="nav-link show"
                        :class="{ active: activeTab === 'description' }"
                        @click="activeTab = 'description'"
                      >
                        Description
                      </div>
                    </li>
                    <li class="nav-item">
                      <div
                        class="nav-link show"
                        :class="{ active: activeTab === 'details' }"
                        @click="activeTab = 'details'"
                      >
                        Details
                      </div>
                    </li>
                    <li class="nav-item">
                      <div
                        class="nav-link show"
                        :class="{ active: activeTab === 'locationMap' }"
                        @click="activeTab = 'locationMap'"
                      >
                        Map
                      </div>
                    </li>
                  </ul>

                  <div
                    v-show="activeTab === 'description'"
                    class="tab-content"
                  >
                    <div class="card-text description-box tab-pane active">
                      <p>{{ petAd.description }}</p>
                    </div>
                  </div>
                  <div
                    v-show="activeTab === 'details'"
                    class="tab-pane"
                  >
                    <!-- İlan detayları -->
                    <div
                      v-if="petAd.category === 'Cats' || petAd.category === 'Dogs'"
                      class="table-responsive"
                    >
                      <ul class="list cat-list">
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>Due Date:</p>
                            <p>{{ petAd.birthDate }}</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>Age of Litter:</p>
                            <p>{{ calculateAge(petAd.birthDate) }}</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>MALEs in Litter:</p>
                            <p>1</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>FEMALEs in Litter</p>
                            <p>0</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>Bloodtype:</p>
                            <p v-if="petAd.bloodType">{{ petAd.bloodType }}</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>Neutered? :</p>
                            <p v-if="petAd.isNeutered">
                              <i
                                class="fa-regular fa-circle-check"
                                style="color: #63e6be"
                              />
                            </p>
                            <p v-else><i
                              class="fa-solid fa-ban"
                              style="color: red"
                            /></p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>Microchipped? :</p>
                            <p v-if="petAd.isMicrochipped">
                              <i
                                class="fa-regular fa-circle-check"
                                style="color: #63e6be"
                              />
                            </p>
                            <p v-else><i
                              class="fa-solid fa-ban"
                              style="color: red"
                            /></p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>Vaccinated? :</p>
                            <p v-if="petAd.isVaccinated">
                              <i
                                class="fa-regular fa-circle-check"
                                style="color: #63e6be"
                              />
                            </p>
                            <p v-else><i
                              class="fa-solid fa-ban"
                              style="color: red"
                            /></p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>Worming? :</p>
                            <p v-if="petAd.isWormTreated">
                              <i
                                class="fa-regular fa-circle-check"
                                style="color: #63e6be"
                              />
                            </p>
                            <p v-else><i
                              class="fa-solid fa-ban"
                              style="color: red"
                            /></p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>Healthchecked? :</p>
                            <p v-if="petAd.isHealthChecked">
                              <i
                                class="fa-regular fa-circle-check"
                                style="color: #63e6be"
                              />
                            </p>
                            <p v-else><i
                              class="fa-solid fa-ban"
                              style="color: red"
                            /></p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="d-flex justify-content-between"
                          >
                            <p>Certificate(s) :</p>
                            <p>{{ petAd.certificate }}</p>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    v-if="activeTab === 'locationMap'"
                    class="tab-pane"
                  >
                    <!-- Harita bölümü -->
                    <div
                      v-if="coordinates"
                      class="map-container"
                    >
                      <l-map
                        ref="map"
                        :zoom="13"
                        :center="coordinates"
                        :use-global-leaflet="false"
                      >
                        <l-tile-layer
                          url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                          layer-type="base"
                          name="OpenStreetMap"
                        />
                        <l-marker :lat-lng="coordinates">
                          <l-popup>
                            <div class="custom-popup">
                              <h5>{{ petAd.title }}</h5>
                              <p>{{ petAd.category }} / {{ petAd.subCategory }}</p>
                            </div>
                          </l-popup>
                        </l-marker>
                      </l-map>
                    </div>
                    <!-- Harita bölümü -->
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="no-data"
            >
              <router-link
                v-if="!loading"
                to="/pets"
              >
                Go to listing page...
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div style="min-height: 100px" />
  </div>
</template>

<script setup>
  /* eslint-disable */
  import { ref, computed, onMounted, watch, onUnmounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { useGetPetAd } from '@/composables/getPetAd';
  import { useViewTracker } from '@/composables/useViewTracker';
  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  import 'vue3-carousel/dist/carousel.css';
  import { Carousel, Slide, Navigation } from 'vue3-carousel';
  import { LMap, LTileLayer, LMarker, LPopup } from '@vue-leaflet/vue-leaflet';
  import 'leaflet/dist/leaflet.css';
  import { Icon } from 'leaflet';
  import VueEasyLightbox from 'vue-easy-lightbox';
  import { storeToRefs } from 'pinia';
  import { useUserStore } from '@/stores/userStore'; // Import'u ekleyin
  import { getAuth } from 'firebase/auth'; // Firebase auth'u import edin
  import { useSendMessage } from '@/composables/sendMessage';

  // User Details
  const auth = getAuth();
  const userStore = useUserStore();
  const { userData } = storeToRefs(userStore);

  // Visitor bilgilerini tek bir computed'da toplayalım
  const visitorInfo = computed(() => {
    const user = auth.currentUser;
    return {
      id: user?.uid || null,
      email: user?.email || null,
      photoURL: user?.photoURL || '/default-avatar.png', // Varsayılan avatar ekleyin
      isLoggedIn: !!user,
      displayName: user?.displayName || null,
      senderPhotoURL: user?.photoURL || '/default-avatar.png',
    };
  });

  const activeTab = ref('description');
  const defaultImage =
    'https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2FnoImage.jpg?alt=media';

  // Mesaj kartını açma fonksiyonu
  const messageCard = ref(false);
  const MessageCardToggle = () => {
    if (!visitorInfo.value.isLoggedIn) {
      // Kullanıcı giriş yapmamışsa login sayfasına yönlendir
      router.push('/login');
      return;
    }
    messageCard.value = !messageCard.value;
  };
  // Slide değiştirme fonksiyonu
  const slideTo = (nextSlide) => (currentSlide.value = nextSlide);

  // Route'dan pet ID'sini al
  const route = useRoute();
  const petId = route.params.id;

  // Composables'tan gerekli değerleri al
  const { petAd, error, loading, fetchPetAd } = useGetPetAd(petId);
  const { recordView } = useViewTracker();

  // Tüm resimleri birleştir
  const removeTokenFromUrl = (url) => {
    return url.split('&token=')[0];
  };

  const allImages = computed(() => {
    if (!petAd.value) return [];

    // Önce tüm resimleri al ve token'ları kaldır
    const images = [...(petAd.value.images || [])].map((img) => removeTokenFromUrl(img));

    // CoverImage'i bul ve varsa listeden çıkar
    if (petAd.value.coverImage) {
      const cleanCoverImage = removeTokenFromUrl(petAd.value.coverImage);
      const coverImageIndex = images.findIndex((img) => img === cleanCoverImage);
      if (coverImageIndex !== -1) {
        images.splice(coverImageIndex, 1);
      }
      // CoverImage'i listenin başına ekle
      images.unshift(cleanCoverImage);
    }

    return images.length ? images : [defaultImage];
  });

  // Carousel ayarlarında currentSlide'ı 0 olarak başlat
  const currentSlide = ref(0);

  // Carousel ayarları
  const galleryConfig = {
    itemsToShow: 1,
    wrapAround: true,
    slideEffect: 'fade',
    mouseDrag: true,
    touchDrag: true,
    height: 500,
  };

  const thumbnailsConfig = {
    height: 80,
    itemsToShow: 6,
    wrapAround: true,
    touchDrag: true,
    gap: 10,
  };

  // Leaflet ikon ayarları
  delete Icon.Default.prototype._getIconUrl;
  Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });

  // GeoPoint'ten koordinatları alma fonksiyonu
  const parseCoordinates = (geoPoint) => {
    try {
      if (!geoPoint || !geoPoint._lat || !geoPoint._long) {
        console.log('Geçersiz GeoPoint verisi:', geoPoint);
        return null;
      }

      return [geoPoint._lat, geoPoint._long];
    } catch (error) {
      console.error('Koordinat parse hatası:', error);
      return null;
    }
  };

  // Koordinatları computed property olarak tanımla
  const coordinates = computed(() => {
    if (!petAd.value?.adLocation) {
      //console.log('adLocation bulunamadı');
      return null;
    }

    const coords = parseCoordinates(petAd.value.adLocation);
    //console.log('İşlenmiş koordinatlar:', coords);
    return coords;
  });
  const formattedCreatedAt = computed(() => {
    if (!petAd.value?.createdAt) return 'No date';
    const date = new Date(petAd.value.createdAt.toDate());
    return date.toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  });

  // Sayfa yüklendiğinde pet ilanını yükle
  onMounted(async () => {
    await fetchPetAd();
    if (petAd.value) {
      recordView(petAd.value);
    }
    // Eğer kullanıcı giriş yapmışsa userData'yı getir
    if (auth.currentUser) {
      await userStore.fetchUserData(auth.currentUser.uid);
    }
  });

  const carousel = ref(null);

  const handleKeydown = (event) => {
    if (event.key === 'ArrowLeft') {
      carousel.value?.prev();
    }
    if (event.key === 'ArrowRight') {
      carousel.value?.next();
    }
  };

  onMounted(() => {
    window.addEventListener('keydown', handleKeydown);
  });

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeydown);
  });

  // Debug için watch
  watch(petAd, (newValue) => {
    if (newValue?.adLocation) {
      //console.log('GeoPoint verisi:', newValue.adLocation);
      //console.log('Koordinatlar:', coordinates.value);
    }
  });

  const visible = ref(false);
  const imageIndex = ref(0);

  const showImg = (index) => {
    imageIndex.value = index;
    visible.value = true;
  };

  const handleHide = () => {
    visible.value = false;
  };

  const calculateAge = (birthDate) => {
    if (!birthDate) return '';

    const today = new Date();
    const birth = new Date(birthDate);

    // Toplam gün farkı
    const diffTime = Math.abs(today - birth);
    const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    // Yıl, ay ve gün hesaplama
    const years = Math.floor(totalDays / 365);
    const months = Math.floor((totalDays % 365) / 30);
    const days = Math.floor((totalDays % 365) % 30);

    // 30 günden az
    if (totalDays < 30) {
      return `${totalDays} day old`;
    }
    // 30 günden fazla 12 aydan az
    else if (totalDays >= 30 && totalDays < 365) {
      return `${months} mo ${days} days old`;
    }
    // 12 aydan fazla
    else {
      return `${years} year ${months} mo ${days} days`;
    }
  };

  const { sendMessage, error: sendError, isPending } = useSendMessage();
  const messageText = ref('');

  // Mesaj gönderme fonksiyonu
  const handleSendMessage = async () => {
    if (!messageText.value.trim() || !visitorInfo.value.isLoggedIn) return;

    const messageData = {
      adId: petAd.value.id,
      adTitle: petAd.value.title,
      coverImage: petAd.value.coverImage || allImages.value[0] || '', // İlanın kapak resmini veya ilk resmi ekle
      senderId: visitorInfo.value.id,
      senderName: visitorInfo.value.displayName || visitorInfo.value.email,
      senderEmail: visitorInfo.value.email,
      senderPhotoURL: visitorInfo.value.photoURL,
      recieverName: petAd.value.ownerName,
      recieverEmail: petAd.value.owner,
      recieverPhotoURL: petAd.value.ownerPhotoURL,
      receiverId: petAd.value.createdBy,
      message: messageText.value.trim(),
    };

    const success = await sendMessage(messageData);

    if (success) {
      messageText.value = ''; // Mesaj alanını temizle
      messageCard.value = false; // Mesaj kartını kapat
    }
  };

  // Visitor durumu değiştiğinde gerekli işlemleri yap
  watch(
    () => visitorInfo.value.isLoggedIn,
    (isLoggedIn) => {
      if (!isLoggedIn) {
        messageCard.value = false; // Kullanıcı çıkış yaptığında mesaj kartını kapat
      }
    },
  );
</script>

<style scoped>
  .pushtop {
    min-height: 80px;
  }
  @media (min-width: 992px) {
    .pushtop {
      min-height: 175px;
    }
  }
  @media (min-width: 1200px) {
    .pushtop {
      min-height: 230px;
    }
  }
  @media (min-width: 992px) {
  }
  .message-card {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    border-style: solid;
    border-color: #000000;
    border-width: 2px;
    border-radius: 10px;
  }

  /* Veya iç div'e border eklemek için */
  .message-card-content {
    background-color: white;
    padding: 20px;
    border: 2px solid #000000;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 90%;
    max-width: 500px;
    position: relative; /* Eklendi */
  }

  /* Close butonu için özel stil */
  .message-card-content .btn-close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
    padding: 8px;
    margin-top: 10px;
    margin-right: 10px;
    background-color: #ffffff;
    border: 1px solid #000000;
  }

  /* Header için margin ekleyin ki buton ile çakışmasın */
  .message-card-header {
    padding-right: 40px; /* Buton için yer açın */
  }

  .description-box {
    min-height: 6em; /* Approximately 4 lines of text */
    height: auto;
    overflow-y: auto;
    line-height: 1.5;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 4px;
  }
  .pet-details {
    padding: 10px;
    max-width: 800px;
    margin: 0 auto;
  }

  .loading,
  .error {
    text-align: center;
    font-size: 1.2rem;
    margin-top: 20px;
  }

  .error {
    color: red;
  }

  .pet-content {
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #f9f9f9;
  }

  .cover-image img {
    width: 100%;
    max-height: 400px;
    object-fit: cover;
    border-radius: 8px;
  }

  .image-gallery {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
  }

  .image-thumbnail {
    width: 80px;
    height: 80px;
    cursor: pointer;
    border: 2px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    transition: border-color 0.3s ease;
  }

  .image-thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .image-thumbnail.active {
    border-color: #42b983; /* Aktif resmin kenarlık rengi */
  }

  .pet-content h1 {
    margin: 20px 0 0;
    font-size: 2rem;
    color: #333;
  }

  .pet-content p {
    margin: 10px 0 0;
    color: #666;
  }

  .no-data {
    text-align: center;
    font-size: 1.2rem;
    color: #888;
  }
  /* Mevcut stillerinize ek olarak */
  .carousel__slide {
    background-color: #bfbfbf1f;
  }
  .gallery-image {
    width: 100%;
    height: auto;
    object-fit: contain;
    border-radius: 8px;
    cursor: pointer;
  }

  .thumbnail {
    cursor: pointer;
    border: 2px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    height: 80px;
  }

  .thumbnail.is-active {
    border-color: #42b983;
  }

  .thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  /* Mevcut stiller... */

  .map-container {
    width: 100%;
    height: calc(55vh - 60px);
    position: relative;
  }

  .custom-popup {
    padding: 10px;
    text-align: center;
    width: 300px;
  }

  /* Carousel navigasyon butonlarını özelleştirme */
  :deep(.carousel__prev),
  :deep(.carousel__next) {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    width: 32px;
    height: 32px;
  }

  :deep(.carousel__prev:hover),
  :deep(.carousel__next:hover) {
    background-color: rgba(0, 0, 0, 0.5);
  }

  .vue-pinch-zoom-container {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 992px) {
    .main_box.ilan-sag {
      display: block !important;
    }
  }
</style>
